import { Card, CardContent, Container } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useStoreState } from 'pullstate';
import React, { useCallback, useEffect, useState } from 'react';
import DataGridTooltips from '../../components/DataGridTooltips.jsx';
import dataGridStyles from '../../components/styles/dataGridStyles.js';
import { AppStore } from '../../stores/AppStore.js';

const RecentGoals = () => {
    const [rows, setRows] = React.useState([]);
    const goals = useStoreState(AppStore, s => s.goals);
    const user = useStoreState(AppStore, s => s.user);
    const employees = useStoreState(AppStore, s => s.employees);
    const [pageSizes, setPageSizes] = useState(10);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: pageSizes,
        page: 0,
    });

    useEffect(() => {
        setPaginationModel((prev) => ({ ...prev, pageSize: parseInt(localStorage.getItem('pageSize')), page: 0 }))
    }, [])

    useEffect(() => {
        goalsFixed()
    }, [goals, user, employees])

    useEffect(() => {
        setNewPageSize()
    }, [pageSizes])

    const setNewPageSize = useCallback((pageSize) => {
        if (pageSize) {
            localStorage.setItem('pageSize', pageSize);
            return
        }
        localStorage.setItem('pageSize', parseInt(localStorage.getItem('pageSize')) || 10);
    }, [paginationModel])

    const columns = [
        {
            field: 'full_name',
            headerName: 'Name',
            headerClassName: 'header-class',
            width: 200,
            renderCell: (params) => (
                <DataGridTooltips value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </DataGridTooltips>
            )
        },
        {
            field: 'department',
            headerName: 'Department',
            headerClassName: 'header-class',
            width: 200,
            renderCell: (params) => (
                <DataGridTooltips value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </DataGridTooltips>
            )
        },
        {
            field: 'created',
            headerName: 'Created At',
            headerClassName: 'header-class',
            width: 150,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {params.value}
                </div>
            )
        },
        {
            field: 'goal_title',
            headerName: 'Goal Title',
            headerClassName: 'header-class',
            width: 300,
            renderCell: (params) => (
                <DataGridTooltips value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </DataGridTooltips>
            )
        },
        {
            field: 'status',
            headerName: 'Status',
            headerClassName: 'header-class',
            width: 235,
            renderCell: (params) => (
                <DataGridTooltips value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </DataGridTooltips>
            )
        },
    ];

    const goalsFixed = () => {
        if (!goals?.length || !employees?.length) return
        const goalsObject = goals.map(goal => {
            const employee = employees.find(employee => employee.id === goal.people_builder.player_id)

            return {
                id: goal.id,
                full_name: employee.full_name,
                department: employee?.department?.department,
                goal_title: goal?.goal_name,
                created: goal?.createdAt.split('T')[0],
                status: goal?.goal_status
            }
        })
        goalsObject.sort((a, b) => new Date(b.created) - new Date(a.created))
        setRows(goalsObject)
    }

    return (
        <Container sx={{ mt: 10 }}>
            <Card sx={{ p: 2, mb: 2 }}>
                <CardContent>
                    {/* <Box sx={{ height: 400, width: '100%', backgroundColor: 'white' }} style={{ display: 'flex', flexDirection: 'column' }}> */}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>

                        <DataGrid
                            disableColumnResize
                            disableRowSelectionOnClick
                            sx={dataGridStyles}
                            rows={rows}
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5]}
                            pageSizeOptions={[10, 15, 20]}
                            paginationModel={paginationModel}
                            onPaginationModelChange={(model) => {
                                setPaginationModel((prev) => ({ ...prev, pageSize: model.pageSize, page: model.page }))
                                setNewPageSize(model.pageSize)
                            }}
                        >
                        </DataGrid>
                    </div>
                    {/* </Box> */}
                </CardContent>
            </Card>
        </Container>
    );
}

export default RecentGoals;